import InboundActions from '@intercom/embercom-composer/mixins/inbound-actions';
import focusInput from '@intercom/embercom-composer/lib/focus-input';
import PopoverPosition from '@intercom/embercom-composer/components/mixins/popover-position';
import $ from 'jquery';
import { and, reads } from '@ember/object/computed';
import { schedule, next } from '@ember/runloop';
import Em from 'ember';
export default Em.Component.extend(InboundActions, PopoverPosition, {
  classNames: ['ic-popup', 'ic-popup-above', 'ic-popup-short'],
  attributeBindings: ['style'],
  keysToTriggerClose: [],
  arrowHeight: 7,
  isWithinViewport: reads('selectionCoordinates.isWithinViewport'),
  hasPositionOffset: and('horizontalPositionOffset', 'verticalPositionOffset'),
  editableObject: reads('currentEditableObject'),
  didInsertElement() {
    this._super(...arguments);
    schedule('afterRender', this, this.setupEditorDimensions);
    next(() => this.autoFocus()); //run.next so that the editor has been positioned correctly
  },
  autoFocus() {
    let autoFocusSelector = this.get('autoFocusSelector');
    if (autoFocusSelector) {
      schedule('afterRender', this, function () {
        focusInput($(autoFocusSelector, this.element));
      });
    }
  },
  cleanData: Em.on('willDestroyElement', function () {
    let editableObject = this.get('editableObject');
    schedule('afterRender', function () {
      if (editableObject) {
        editableObject.cleanData();
      }
    });
  }),
  deleteEntityIfPropertyBlank() {
    let key = this.get('deleteIfPropertyBlank');
    if (key) {
      let value = this.get(key);
      if (value.trim() === '') {
        this.send('delete');
      }
    }
  },
  handleKeyDown: Em.on('keyDown', function (e) {
    let key = e.which || e.keyCode;
    if (this.keysToTriggerClose.includes(key)) {
      this.deleteEntityIfPropertyBlank();
      this.send('dismiss');
      if (!this.get('keepSelectedOnDismiss')) {
        this.moveSelectionPastEntityOrBlock?.();
      }
      e.preventDefault();
    }
  }),
  actions: {
    delete() {
      this.deleteEntity?.(this.get('editableObject.id'));
    },
    dismiss() {
      this.hideEditor?.(this.get('editableObject.id'));
    }
  }
});